export type LoginBrand = "nexus" | "connectx"

export interface PublicLoginBranding {
  configured: boolean
  host?: string
  id?: string
  name: string
  tagline?: string
  logo_url?: string | null
  favicon_url?: string | null
}

const CONNECTX_HOSTNAME = "connectx.mbanet.com.pk"

export const getLoginBrandForHostname = (hostname: string): LoginBrand => {
  return hostname.toLowerCase() === CONNECTX_HOSTNAME ? "connectx" : "nexus"
}

export const getCurrentLoginBrand = (): LoginBrand => {
  if (typeof window === "undefined") return "nexus"
  return getLoginBrandForHostname(window.location.hostname)
}

export const getConnectxLogoSrc = () => `${process.env.PUBLIC_URL || ""}/connectx_logo.png`

export const getDefaultLoginCompanyName = () => {
  const brand = getCurrentLoginBrand()
  return brand === "connectx" ? "CONNECTX" : "MBA NET"
}

export const getDefaultLoginFavicon = () => {
  const brand = getCurrentLoginBrand()
  return brand === "connectx" ? getConnectxLogoSrc() : "/favicon.ico"
}
